import React, { Component, useState, Fragment } from "react";
import { Modal, Button, Form } from "react-bootstrap";

import Cookies from 'js-cookie'
import settings from '../../settings.json';


export default class Footer extends Component{
  state={
  }
  
  constructor(props) {
    super(props);
  }
  
  componentDidMount () {

  }
  

  handleChange = (e) => {
    console.dir(e);
  }
  
  
  
  render(){
    return (
      <footer>

      </footer>
    );
  }
}